<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Configure External Integration</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content class="bottom-extra-gap"
      ><mat-checkbox (change)="showPassword = !showPassword"> Show Password </mat-checkbox>
      <ng-container>
        <mat-form-field class="flex-full">
          <mat-label>Username</mat-label>
          <input
            matInput
            autocomplete="off"
            type="text"
            [formControl]="form.get('username')"
            required
            id="presence-username-input"
            />@if (form.get('username')?.hasError('maxlength')) {
            <mat-error>
              Username cannot be more than 255 characters long. </mat-error
              >
            }@if (form.get('username')?.hasError('required')) {
            <mat-error> Username is required </mat-error>
          }
        </mat-form-field>
      </ng-container>
      <ng-container>
        <mat-form-field class="flex-full">
          <mat-label>New Password</mat-label>
          <input
            matInput
            autocomplete="off"
            [type]="showPassword ? 'text' : 'password'"
            [formControl]="form.get('password')"
            id="presence-password-input"
            />
            @if (
              form.get('password')?.hasError('minlength') ||
              form.get('password')?.hasError('maxlength') ||
              form.get('password')?.hasError('specialcharacters') ||
              form.get('password')?.hasError('uppercasecharacters') ||
              form.get('password')?.hasError('numericcharacters')
              ) {
              <mat-error
                >
                Password must be at least 8 - 255 characters and contain an uppercase character, a numeric character,
                and a special character
              </mat-error>
            }
            @if (form.get('password')?.hasError('required')) {
              <mat-error> Password is required. </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-full">
            <mat-label>Confirm New Password</mat-label>
            <input
              matInput
              autocomplete="off"
              [type]="showPassword ? 'text' : 'password'"
              [formControl]="form.get('confirmPassword')"
              id="presence-confirm-password-input"
              />
              @if (form.get('password')?.hasError('required')) {
                <mat-error
                  >Confirm New Password is required.
                </mat-error>
              }
              @if (form.get('confirmPassword')?.hasError('validPassword')) {
                <mat-error>
                  New Password and Confirm New Password must match.
                </mat-error>
              }
            </mat-form-field>
          </ng-container>
        </mat-dialog-content>
        <mat-dialog-actions>
          <button type="submit" title="Create" mat-raised-button>Save</button>
        </mat-dialog-actions>
      </form>
    </lcs-loading-overlay>
